import React, { useCallback, useContext, useEffect, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { ThemeContext } from 'styled-components';

import { ReactComponent as BackIcon } from '@pkg/components/Sections/Profile/icons/icon-back.svg';

import {
    BackIconWrapper,
    CHARACTER_LIMIT_CLASS_NAME,
} from '@app/pages/Prototype/Grid/ItemEditMobile/LinkAttributeInput/styles';

import { InputContainer, InputWrapper, StyledInput, StyledTypography } from './styles';

interface Props {
    hasBackButton?: boolean;
    onClose: () => void;
    onUpdated: (newValue) => void;
    onChange?: (newValue) => void;
    placeholder: string;
    characterLimit: number;
    value: string | undefined | null;
}

export const AttributeInput = ({
    characterLimit,
    hasBackButton = true,
    onClose,
    value = '',
    placeholder,
    onUpdated,
    onChange,
}: Props) => {
    const theme = useContext(ThemeContext);
    const [editingValue, setEditingValue] = useState<string>();

    const updateItem = useCallback(
        (updatedItem) => {
            onUpdated(updatedItem);
        },
        [onUpdated],
    );
    //TODO:  this component could be simplified
    const handleChangeValue = (newValue: string) => {
        setEditingValue(newValue);
        updateItem(newValue);
        onChange?.(newValue);
    };

    useEffect(() => {
        if (value) {
            setEditingValue(value);
        }
    }, [value]);

    return (
        <InputWrapper>
            <InputContainer>
                <AnimatePresence initial={false}>
                    {hasBackButton && (
                        <BackIconWrapper
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{
                                duration: theme.transitions.speeds.normal,
                                ease: theme.transitions.eases.cubic,
                            }}
                            onClick={onClose}
                        >
                            <BackIcon />
                        </BackIconWrapper>
                    )}
                </AnimatePresence>
                <StyledTypography type="paragraph" weight="400" size={16} color="white">
                    <StyledInput
                        autoFocus
                        value={editingValue}
                        multipleLines
                        $multiline
                        characterLimit={characterLimit}
                        characterLimitClassName={CHARACTER_LIMIT_CLASS_NAME}
                        onChange={handleChangeValue}
                        onBlur={onClose}
                        onEnterKeyDown={onClose}
                        placeholderText={placeholder}
                    />
                </StyledTypography>
            </InputContainer>
        </InputWrapper>
    );
};
